var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Helmet = require('react-helmet');
var Loader = require('react-loader');
var Link = require('react-router').Link;
var moment = require('moment');
var DatePicker = require('../../components/datePicker.jsx');
var ProfileFAQList = require('./layout/profileFAQList.jsx');
var Callout = require('../../components/callout.jsx');

var Profile = createReactClass({
	mixins: [PureRenderMixin],

    getInitialState: function(){
        return {
            dob: '',
			gender: this.getProfile().sex
        };
    },

	componentWillUnmount: function(){
		this.props.clearProfileError();
		this.props.clearProfileSuccess();
	},

    handleDateChange: function(month, day, year){
        this.setState({dob: month + '/' + day + '/' + year});
    },

	handleGenderChange: function(event){
		var selectEle = event.currentTarget;
		this.setState({gender: selectEle.options[selectEle.selectedIndex].value});
	},

    handleSubmit: function(event) {
        event.preventDefault()
        this.props.updateProfile(
			this.refs.firstName.value.trim(),
			this.refs.lastName.value.trim(),
			this.state.gender,
			this.state.dob,this.refs.postalCode.value.trim(),
			this.props.auth.token
		);
    },

    handleClickTracking: function(event){
        var target = event.target;
        var label = target.innerText;
        var action = 'Click';
        this.props.recordProfileClick(action, label);
    },

	handleTabClick: function(event){
		event.preventDefault();

		var $clickedTab = $(event.currentTarget);
		$clickedTab.addClass('active').siblings().removeClass('active');

		$('[id$="Pane"]').removeClass('active');
		$($clickedTab.attr('href')).addClass('active');
	},

    getProfile: function(){
        return Object.keys(this.props.profile.data).length > 0 ? this.props.profile.data : {};
    },

    hasDataLoaded: function(){
        return Object.keys(this.getProfile()).length > 0;
    },

    getContent: function(){
        var error = this.props.profile.error;
        var profile = this.getProfile();

        var dob = new moment();

        if(this.hasDataLoaded() && profile.dateOfBirth){
            dob = moment.utc(profile.dateOfBirth);
        }

		var month = dob.month() + 1; // months are 0-indexed
		var day = dob.date();
		var year = dob.year();

        var children = [
			<div className="content-header-wrapper" key="content-header">
				<div className="content-header-small content-header row column">
					<h1>Your Account</h1>
				</div>
			</div>,
			<div className="tab-wrapper show-for-small-only" key="tab-wrapper">
				<a href="#mainPane" className="tab active" onClick={this.handleTabClick}>Edit Profile</a>
				<a href="#sidePane" className="tab" onClick={this.handleTabClick}>FAQ</a>
			</div>,
            <div className="row" key={0}>
                <div className="medium-5 small-12 column active" id="mainPane">
                    <div className="main">
                        <div className="special-form-box-wrapper">
							<div className="user-head">
								<p>{profile.firstName} {profile.lastName}</p>
							</div>
                            {Object.keys(error).length !== 0 &&
                                <Callout type="alert" message={error} handleClose={this.props.clearProfileError} />
                            }
                            {this.props.profile.success &&
                                <Callout type="success" message={this.props.profile.success} handleClose={this.props.clearProfileSuccess} />
                            }
                            <div className="register-box special-form-box">
                                <form onSubmit={this.handleSubmit} noValidate autoComplete="off">
									<p className="input-field-title">Profile Information</p>
									<div className="input-field-wrapper">
										<div className="input-field">
                                            <label className="heading" htmlFor="firstName">First Name</label>
                                            <input type="text" name="firstName" id="firstName" ref="firstName" placeholder="John" required defaultValue={profile.firstName} />
                                        </div>
                                        <div className="input-field">
                                            <label className="heading" htmlFor="lastName">Last Name</label>
                                            <input type="text" name="lastName" id="lastName" ref="lastName" placeholder="Smith" required defaultValue={profile.lastName} />
                                        </div>
									</div>

									<div className="input-field-wrapper">
										<div className="postalCode-input-field input-field">
	                                        <label htmlFor="postalCode" className="heading">ZIP Code</label>
	                                        <input type="text" name="postalCode" id="postalCode" ref="postalCode" placeholder="ZIP Code" required defaultValue={profile.postalCode} />
											<div className="tip">
												<span className="ion-ios-information-outline"></span>
												<p>Your location helps us find relevant clinical trials near you</p>
											</div>
	                                    </div>
									</div>

									<div className={'gender-picker input-field-wrapper ' + this.state.gender}>
										<div className="input-field">
											<label className="heading" htmlFor="gender">Gender</label>
											<div className="select-container">
												<select name="gender" id="gender" ref="gender" value={this.state.gender} onChange={this.handleGenderChange}>
													<option value="male">Male</option>
													<option value="female">Female</option>
												</select>
											</div>
										</div>
									</div>

									<p className="input-field-title">Birthdate</p>
									<DatePicker month={month} day={day} year={year} onDateChange={this.handleDateChange} />

									<p className="show-for-medium"><Link to="/password-reset">Reset Password</Link></p>

                                    <button className="button" type="submit" onClick={this.handleClickTracking}>Update Your Information</button>
									<button className="button secondary show-for-medium" onClick={this.props.onLogout}>Log Out</button>
									<Link className="button secondary show-for-small-only" to="/password-reset">Reset Password</Link>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="medium-7 small-12 column end" id="sidePane">
                    <div className="side">
                        <h2>FAQ</h2>
                        <ProfileFAQList />
                    </div>
                </div>
            </div>
        ];

        var content = (
            <Loader loaded={this.hasDataLoaded()}>
                {children}
            </Loader>
        );

        if(this.hasDataLoaded()){
            content = children;
        }

        return content;
    },

    render: function(){
        return (
            <div className="content">
                <Helmet title='Profile' />
                {this.getContent()}
            </div>
        );
    }
});

module.exports = Profile;



// WEBPACK FOOTER //
// ./src/common/routes/profile/components/profile.jsx